import type { CopybookTemplatePreset } from '../store/copybookStore'

interface TemplateGalleryProps {
  templates: CopybookTemplatePreset[]
  activeTemplateId: string | null
  onSelect: (template: CopybookTemplatePreset) => void
}

export default function TemplateGallery({ templates, activeTemplateId, onSelect }: TemplateGalleryProps) {
  return (
    <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
      {templates.map((template) => {
        const active = activeTemplateId === template.id
        return (
          <button
            key={template.id}
            onClick={() => onSelect(template)}
            className={`rounded-2xl border p-4 text-left transition-all ${
              active
                ? 'border-blue-600 bg-blue-50 shadow-sm'
                : 'border-gray-200 bg-white hover:border-gray-300 hover:shadow-sm'
            }`}
          >
            <div className="flex items-start justify-between gap-3">
              <div>
                <h3 className="text-base font-semibold text-gray-900">{template.name}</h3>
                <p className="mt-1 text-sm text-gray-600">{template.description}</p>
              </div>
              <span className={`rounded-full px-2 py-1 text-xs font-medium ${active ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-600'}`}>
                A4
              </span>
            </div>
            <div className="mt-3 flex flex-wrap gap-2 text-xs text-gray-600">
              <span className="rounded-full bg-gray-100 px-2 py-1">{template.gridType}</span>
              <span className="rounded-full bg-gray-100 px-2 py-1">{template.colsPerRow} 格/行</span>
              <span className="rounded-full bg-gray-100 px-2 py-1">{template.gridSize}mm</span>
            </div>
          </button>
        )
      })}
    </div>
  )
}

